import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as Config from '../config'
import Cookies from 'js-cookie'
import imageCompression from 'browser-image-compression'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {}
  },
  actions: {
    // Inicio Peticiones de auth
    login({ commit }, form) {
      // commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + '/auth/login_admins', form)
          .then((response) => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token
              commit('SET_USER', {
                id_role: response.data.data.id_role,
                admin_id: response.data.data.admin_id,
                first_name: response.data.data.first_name,
                last_name: response.data.data.last_name,
                email: response.data.data.email
              })
              /* onst username = response.data.data.full_name;
             const useremail = response.data.data.email;
             const profile = response.data.data.profile_picture;
             const id_role = response.data.data.role; */
              const id = response.data.data.admin_id
              Cookies.set('access_token', accessToken)
              /*  Cookies.set("user_name", username)
              Cookies.set("user_email", useremail)
              Cookies.set("picture", profile)
              Cookies.set("id_role", id_role) */
              Cookies.set('id', id)
              // commit("LOGIN", response.data);
              resolve(response.data)
            } else {
              commit('LOGIN_FAIL1')
              reject(response.data)
            }
          })
          .catch((error) => {
            console.log('LOGIN_FAIL')
            console.log(error)
            reject(error)
          })
      })
    },
    logout() {
      Cookies.remove('access_token')
      Cookies.remove('id')
      location.reload(true)
    },

    // DEFINITIONS

    getData({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(
            Config.apiPath + '/' + form.url,
            { params: form.params },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('access_token')}`
              }
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    createData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form.data)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + '/' + form.url, form.data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${Cookies.get('access_token')}`
            }
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    updateData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + '/' + form.url + '/' + form.id, form.data)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    changeStatusData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(
            Config.apiPath + '/' + form.url + '/' + form.id + '/' + form.status
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    getFile({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(
            Config.apiPath +
              '/upload/all?active=1&type=' +
              form.type +
              '&page=' +
              form.page
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },
    getFileMemeRequests({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + '/upload/meme/all')
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    UploadFile({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + '/upload/file', form)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    FileStatus({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(
            Config.apiPath +
              '/upload/change_status/' +
              form.id +
              '/' +
              form.status
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    getVideo({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + '/upload/all?active=1')
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },

    UploadVideo({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post('https://apibit.ticktaps.xyz/api/1.0/upload/file', form)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            resolve(error.response.data)
            reject(error.response.data)
          })
      })
    },

    async optimizeImage({ commit }, file) {
      console.log(file)
      console.log(commit)

      const imageTypes = ['image/jpeg', 'image/png']

      if (!imageTypes.includes(file.type)) {
        return file
      }

      const options = {
        maxSizeMB: 0.7,
        maxWidthOrHeight: 1000,
        useWebWorker: true
      }

      try {
        const compressedFile = await imageCompression(file, options)
        return compressedFile
      } catch (error) {
        console.error(error)
        throw error
      }
    }
  },
  mutations: {
    SET_USER(state, userData) {
      state.user = userData
    }
  }
})
